"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const Card_vue_1 = __importDefault(require("@/client/components/card/Card.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'stacked-cards',
    props: {
        cards: {
            type: Array,
            required: true,
        },
    },
    components: {
        Card: Card_vue_1.default,
    },
});
